var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseTransition", { attrs: { animation: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$ui.showOverlay,
            expression: "$ui.showOverlay"
          }
        ],
        staticClass: "fixed inset-0 z-40"
      },
      [_c("div", { staticClass: "absolute inset-0 bg-gray-500 opacity-75" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }